
    import {computed, ComputedRef,
    defineComponent, reactive, watch, 
    nextTick} from 'vue'
    import {useStore} from "@/store";
    // import {useRoute} from "vue-router";
    import utils from '@/util/index';
    import { Switch, Tabs, Tab } from 'scvant';
    import componentTitle from './componentTitle.vue';

    interface State {
        isShowTopNav: boolean;
        needListenScroll: boolean;
        currentName: string;
        topValue: number;
        offsetTop: number;
        checkModules: any;
        logoUrl: string;
        channelType: string;
        onlyFlaw: boolean;
        hasWarn: boolean;
        checkItemModules: any;
        currentCode: string;
        tabList: any;
        checkItemMainHeight: any;
        checkItemMainOffsetTop: any;
        queryModules: any;
    }

    export default defineComponent({
        name: "navigation",
        setup() {
            let state: State = reactive({
                isShowTopNav: false, // nav
                needListenScroll: true, // 监听滚动
                currentName: '基础信息',
                topValue: 0,
                offsetTop: 0,
                checkModules: [],
                logoUrl: '',
                channelType: '',
                onlyFlaw: false,
                hasWarn: true,
                checkItemModules: {},
                currentCode: 'Accident',
                tabList: [],
                checkItemMainHeight: {},
                checkItemMainOffsetTop: {},
                queryModules: []
            })
            // const tabListRef: any = ref(null);
            // const {query} = useRoute();
            const store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            let tocOnlyShowFlaw: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            function isShowCurrentModel (checkModules: any,modelName: string): any {
                let containJiaGou = {};
                if (!checkModules) {
                    containJiaGou = {};
                }
                for (let i=0;i<checkModules.length;i+=1) {
                    if (checkModules[i].code === modelName) {
                        containJiaGou = checkModules[i];
                    }
                }
                return containJiaGou;
            }
            function setScrollNum(){
                let header: any = document.getElementById("entrust");
                let checkItemMain: any = document.getElementById("checkItemMain");
                if (header) {
                    // 这里要得到top的距离和元素自身的高度
                    state.offsetTop = header.offsetTop;
                }
                if (checkItemMain) {
                    state.checkItemMainHeight = checkItemMain.clientHeight;
                    state.checkItemMainOffsetTop = checkItemMain.offsetTop;
                }
            }
            watch(dataInfo, (data: any) => {
                const { checkItemModules, haveDefect, checkModules, queryModules } = data;
                state.hasWarn = haveDefect;
                state.checkItemModules = checkItemModules;
                state.checkModules = checkModules;
                state.queryModules = queryModules;
                let tabListD: any[] = [];
                if (state.onlyFlaw) {
                    tabListD = [...checkItemModules.map(item => item.defectItemCount>0 )];
                } else {
                    tabListD = [...checkItemModules];
                    let queryArray: any[] = state.queryModules;
                    if (queryArray && queryArray.length) {
                        tabListD.push({
                            itemTitle: '历史车况数据',
                            itemCode: 'history',
                        });
                    }
                }
                let plusEcuModule = isShowCurrentModel(checkModules,'PlusEcuInfo');
                let plusEcuModuleArr = Object.keys(plusEcuModule);
                if (plusEcuModuleArr.length > 0) {
                    let newTabListD = [...tabListD];
                    if (state.onlyFlaw) {
                        if (plusEcuModule.defectCount > 0) {
                            let plusEcu = {"itemCode":"PlusEcuInfo","itemTitle":"【加购】ECU检测"};
                            (newTabListD as any).push(plusEcu);
                        }
                    }else {
                        let plusEcu = {"itemCode":"PlusEcuInfo","itemTitle":"【加购】ECU检测"};
                        (newTabListD as any).push(plusEcu);
                    }
                     state.tabList = newTabListD;
                } else {
                    state.tabList = tabListD;
                }
            })
            watch(tocOnlyShowFlaw, (data: any) => {
                state.onlyFlaw = data;
                let tabListD: any[] = [];
                if (state.onlyFlaw) {
                    let tempArray: any[] = [];
                    if (state.checkItemModules && state.checkItemModules.length) {
                        tempArray = [...state.checkItemModules];
                    }
                    for (let i =0;i<tempArray.length;i++) {
                        let item = tempArray[i];
                        if (item.defectItemCount>0){
                            (tabListD as any).push(item);
                        }
                    }
                } else {
                    if (state.checkItemModules && state.checkItemModules.length) {
                        tabListD = [...state.checkItemModules];
                    }
                    let queryArray: any[] = state.queryModules;
                    if (queryArray && queryArray.length) {
                        tabListD.push({
                            itemTitle: '历史车况数据',
                            itemCode: 'history',
                        });
                    }
                }
                let plusEcuModule = isShowCurrentModel(state.checkModules,'PlusEcuInfo');
                let plusEcuModuleArr = Object.keys(plusEcuModule);
                if (plusEcuModuleArr.length > 0) {
                    let newTabListD = [...tabListD];
                    if (state.onlyFlaw) {
                        if (plusEcuModule.defectCount > 0) {
                            let plusEcu = {"itemCode":"PlusEcuInfo","itemTitle":"【加购】ECU检测"};
                            (newTabListD as any).push(plusEcu);
                        }
                    } else {
                        let plusEcu = {"itemCode":"PlusEcuInfo","itemTitle":"【加购】ECU检测"};
                        (newTabListD as any).push(plusEcu);
                    }
                     state.tabList = newTabListD;
                } else {
                    state.tabList = tabListD;
                }
            })
            function changeShowFlaw(data) {
                store.dispatch('saveTocOnlyShowFlaw', data);
            }
            function getElementToPageTop (el) {
                if (el.offsetParent) {
                    return getElementToPageTop(el.offsetParent) + el.offsetTop
                }
                else {
                    return el.offsetTop
                }
            }
            return {
                state,
                // scrollToTop,
                changeShowFlaw,
                setScrollNum,
                getElementToPageTop
            }
        },
        mounted() {
            this.setScrollNum();
            window.addEventListener('scroll', this.scrollToTop);
        },
        computed: {
            
        },
        methods: {
            clickTab(name: string) { // 点击tab切换
                let fileData = this.state.tabList.filter(el => {
                    return el.itemCode === name
                });
                const id: string = fileData[0].itemCode;
                this.state.needListenScroll = false;
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                const topNum = this.getElementToPageTop(eTopEl);
                utils.scrollTop(window, sTop, topNum - 60, 500);
                setTimeout(() => {
                    this.state.needListenScroll = true;
                }, 300);
                this.state.currentName = name
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
            },
            scrollToTop: utils.debounce(function(this){
                this.setScrollNum();
                if (!this.state.needListenScroll) return;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // const listEl = document.getElementById('checkItemList');
                if (scrollTop >= this.state.checkItemMainOffsetTop && scrollTop <= this.state.checkItemMainHeight + this.state.checkItemMainOffsetTop) {
                    this.state.isShowTopNav = true;
                } else {
                    this.state.isShowTopNav = false;
                }
                if (this.state.tabList && this.state.tabList.length> 0) {
                    this.state.tabList.forEach((item: any) => {
                        const getTopEl: any = document.getElementById(item.itemCode);
                        let getTop = this.getElementToPageTop(getTopEl);
                        if (scrollTop >= getTop - this.state.topValue - 60) {
                            this.state.currentName = item.itemCode;
                        }
                    });
                }
                
                let activeEl: any = document.getElementById(`${this.state.currentName}1`);
                if(activeEl) {
                    activeEl.scrollIntoView({inline: 'center'});
                }
            }, 17)
        },
        components: {
            // componentTitle,
            [Switch.name]: Switch,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        unmounted() {
             window.removeEventListener('scroll', this.scrollToTop)
        }
    })
